module.exports = __webpack_public_path__ + "static/media/ban.07ef9021.svg";